import DealsPreview from './DealsPreview';

export default DealsPreview;
